<template>
  <q-page class="flex flex-center">
    <div v-if="message" class="q-ma-lg">
      <q-alert color="blue-4" icon="info" enter="fadeIn" leave="fadeOut" appear dismissible>
        <b>Logged out:</b>
        {{ message }}
      </q-alert>
    </div>
    <form @submit.prevent="submitLogin">
      <q-card class="md-card q-mt-lg relative-position" color="grey-1">
        <q-card-main>
          <q-field
            label="Email"
            orientation="vertical"
            icon="account_box"
            class="q-mt-lg q-mb-lg text-black"
          >
            <q-input v-model="form.userName" type="email" autofocus/>
          </q-field>
          <q-field
            icon="lock"
            orientation="vertical"
            label="Password"
            class="q-mt-lg q-mb-lg text-black"
          >
            <q-input v-model="form.password" type="password" label="Password"/>
          </q-field>
          <div v-if="error" class="q-mt-lg q-mb-lg">
            <q-alert
              color="negative"
              icon="error"
              enter="fadeIn"
              leave="fadeOut"
              appear
              dismissible
            >
              <b>Login Failed:</b>
              {{ error }}
            </q-alert>
          </div>
          <div>
            <q-btn
              label="Forgot Password?"
              color="primary"
              size="sm"
              flat
              class="full-width"
              @click="$router.push('/auth/forgot')"
            />
          </div>
        </q-card-main>
        <q-card-actions>
          <q-btn
            v-model="loading"
            loader
            large
            color="primary"
            class="full-width no-shadow"
            :disabled="loading"
            type="submit"
            label="Login"
          >
            <span slot="loading">
              <q-spinner class="on-left"/>Logging in...
            </span>
          </q-btn>
        </q-card-actions>
        <q-inner-loading :visible="loading"/>
      </q-card>
    </form>
  </q-page>
</template>
<style></style>
<script>
  import {mapActions, mapState} from 'vuex'

  export default {
  name: 'LoginPage',
  data () {
    return {
      loading: false,
      error: null,
      message: null,
      form: {
        userName: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    async submitLogin () {
      this.loading = true
      this.error = null
      this.message = null
      try {
        const { data } = await this.$axios.post('/api/auth/login', this.form)
        if (data && data.token) {
          this.$store.commit('auth/SET_AUTH', data)
          this.loading = false
          // this.$router.push('/admin')
          this.$router.push('../../')
          this.$q.notify({
            message: 'You are now logged in'
          })
          location.reload()
        }
      } catch (e) {
        this.$handleError(e, this)
        this.loading = false
        this.error = 'Invalid credentials'
      }
    }
  },
  mounted () {
    if (this.$route.query.logout) {
      if (this.$route.query.logout === 'success') {
        this.$set(this, 'message', 'You have been logged out successfully')
      }
      if (this.$route.query.logout === 'inactivity') {
        this.$set(this, 'message', 'You have been logged out due to inactivity')
      }
    }
  }
}
</script>
